// Content sourced from the ANTE MERIDIAN ARCHITECTS (AMA) portfolio.

export const studio = {
  name: "Ante Meridian Architects",
  short: "AMA",
  location: "Dubai, UAE",
  email: "antemeridian.arch@gmail.com",
  phone: "+971 50 520 5460",
  instagram: "@antemeridian.architects",
  instagramUrl: "https://instagram.com/antemeridian.architects",
  statement:
    "Designing architecture that balances clarity, context and experience.",
  disciplines: ["Architecture", "Interiors", "Landscape"],
};

export const services = [
  {
    index: "01",
    title: "Architecture",
    body: "Comprehensive 2D and 3D design support across every project stage, from concept coordination to accurate physical models produced through 3D printing.",
  },
  {
    index: "02",
    title: "Interior Design",
    body: "Refined, liveable interiors built on considered palettes, layered textures and warm light — spaces designed to feel calm, connected and quietly luxurious.",
  },
  {
    index: "03",
    title: "Landscape",
    body: "Outdoor environments drawn from context and cultural memory. Courtyards, water and planting composed to shape movement, shade and moments of pause.",
  },
  {
    index: "04",
    title: "Consultancy",
    body: "Tender packages, measured site surveys, detailed BOQs and end-to-end project management for designers and contractors — precision through documentation.",
  },
];

export const projects = [
  {
    id: "elements-and-polygons",
    title: "Elements & Polygons",
    category: "Landscape",
    location: "Emirates Hills",
    year: "2024",
    discipline: "Landscape",
    cover: "/projects/elements-and-polygons-cover.jpg",
    intro:
      "A grand classical-style residence composed to create an elegant, serene arrival experience.",
    description:
      "The architecture features symmetrical white columns, refined stone finishes and a spacious entrance court that heightens the sense of luxury. A long, narrow water feature with small fountains runs along the front of the house, adding movement and a peaceful atmosphere — especially at night, under soft light. Trees, planting and small garden areas bring nature into the composition, forming a quiet outdoor corner connected to its environment and cultural memory: a place to pause, gather and experience the landscape.",
    gallery: [
      "/projects/elements-and-polygons-1.jpg",
      "/projects/elements-and-polygons-2.jpg",
      "/projects/elements-and-polygons-3.jpg",
      "/projects/elements-and-polygons-4.jpg",
    ],
  },
  {
    id: "space-in-neutrals",
    title: "Space in Neutrals",
    category: "Interior Design",
    location: "Dubai Hills",
    year: "2024",
    discipline: "Interiors",
    cover: "/projects/space-in-neutrals-cover.jpg",
    intro:
      "A modern family villa designed to feel calm, comfortable and welcoming.",
    description:
      "The goal was to create spaces that read as refined yet remain easy to live in every day. A soft palette of neutral tones, warm lighting and layered textures runs throughout the home, letting each room feel connected while keeping its own character. The living areas are open and inviting, the master bedroom minimal and restful, and the nursery introduces a softer, playful touch while holding the overall language. The result balances modern simplicity with genuine warmth.",
    gallery: [
      "/projects/space-in-neutrals-1.jpg",
      "/projects/space-in-neutrals-2.jpg",
      "/projects/space-in-neutrals-3.jpg",
      "/projects/space-in-neutrals-4.jpg",
    ],
  },
  {
    id: "palms-with-falaj",
    title: "Palms with Falaj",
    category: "Landscape",
    location: "Arabian Ranches",
    year: "2023",
    discipline: "Landscape",
    cover: "/projects/palms-with-falaj-cover.jpg",
    intro:
      "A landscape drawn from the traditional Falaj irrigation system of the UAE.",
    description:
      "Where water channels once quietly shaped movement and life within a settlement, the design interprets that idea through a simple pergola structure and a linear ground layout that guides circulation and activity. Set within a sandy courtyard and framed by palm trees, the wooden pergola creates shade while echoing the calm rhythm of traditional water channels and oasis landscapes — a quiet outdoor corner connected to local environment and memory, offering a comfortable place to pause, gather and experience the land.",
    gallery: [
      "/projects/palms-with-falaj-1.jpg",
      "/projects/palms-with-falaj-2.jpg",
      "/projects/palms-with-falaj-3.jpg",
      "/projects/palms-with-falaj-4.jpg",
    ],
  },
  {
    id: "bowl-away",
    title: "Bowl Away",
    category: "Commercial",
    location: "Dubai",
    year: "2023",
    discipline: "Commercial",
    cover: "/projects/bowl-away-cover.jpg",
    intro:
      "A bowling alley designed to feel lively, immersive and unmistakably social.",
    description:
      "Soft purple and blue light spreads across the lanes while patterned ceiling lights create a sense of movement overhead. Bright lane numbers and colourful wall art add energy, turning a simple game into a social experience where people relax, play and enjoy the atmosphere. Dynamic LED ceiling patterns, neon lane numbering and ambient ultraviolet lighting build a futuristic visual experience, while reflective flooring and a rhythmic lighting grid enhance depth and movement across the lanes.",
    gallery: [
      "/projects/bowl-away-1.jpg",
      "/projects/bowl-away-2.jpg",
      "/projects/bowl-away-3.jpg",
      "/projects/bowl-away-4.jpg",
    ],
  },
  {
    id: "car-showroom",
    title: "Car Showroom",
    category: "Commercial",
    location: "LMG Motors",
    year: "2022",
    discipline: "Commercial",
    cover: "/projects/car-showroom-cover.jpg",
    intro:
      "A showroom designed to feel modern, welcoming and quietly luxurious.",
    description:
      "Large glass walls create openness and let natural light flow inside, giving visitors a clear view of the elegant interiors. Warm wood tones, marble textures and soft lighting build a comfortable environment rather than a typical commercial showroom. A large display wall with backlit shelves showcases decor pieces and awards, adding character and depth, while lounge-like seating encourages relaxed conversation between clients and sales teams. Modern geometric ceiling lights add a contemporary touch while keeping the atmosphere calm and refined.",
    gallery: [
      "/projects/car-showroom-1.jpg",
      "/projects/car-showroom-2.jpg",
      "/projects/car-showroom-3.jpg",
      "/projects/car-showroom-4.jpg",
    ],
  },
];

export const getProject = (id) => projects.find((p) => p.id === id);

export const filterCategories = [
  "All",
  ...Array.from(new Set(projects.map((p) => p.discipline))),
];
